module.exports = {
	"ha": "vcha",
	"id": 4.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		},
		"defs": {
			"patterns": [
				{
					"id": "polka-dot-1",
					"width": 3.25,
					"height": 3.25,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 0.75, 0.75 m -0.5625, 0 a 0.5625,0.5625 0 1,0 1.125,0 a 0.5625,0.5625 0 1,0 -1.125,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2a",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 1, 1 m -0.75, 0 a 0.75,0.75 0 1,0 1.50,0 a 0.75,0.75 0 1,0 -1.50,0",
						"fill": "#9d070d"
					}
				},
				{
					"id": "polka-dot-2b",
					"width": 3,
					"height": 3,
					"backgroundColor": "#6bcff6",
					"patternTransform": "rotate(45)",
					"path": {
						"d": "M 2, 2 m -1.50, 0 a 1.50,1.50 0 1,0 3,0 a 1.50,1.50 0 1,0 -3,0",
						"fill": "#9d070d"
					}
				}
			]
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 710,
			"height": 355,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " ({point.percentage:.1f}%)"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 4.3</span>                 <span style=\"display: table-cell;\">Stage of HIV Infection at Diagnosis by Age for Vancouver Coastal Health <sup style=\"font-size: 10px;\">5</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0
			},
			"column": {
				"stacking": "percent"
			}
		},
		"colors": [
			"#6bcff6",
			"url(#polka-dot-1)",
			"url(#polka-dot-2a)",
			"url(#polka-dot-2b)",
			"#9d070d"
		],
		"xAxis": [
			{
				"offset": 10,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"labels": {
					"rotation": 0,
					"style": {
						"textOverflow": "none"
					}
				},
				"categories": [
					2017,
					2018,
					2019,
					2020,
					2021,
					"",
					2017,
					2018,
					2019,
					2020,
					2021,
					"",
					2017,
					2018,
					2019,
					2020,
					2021,
					"",
					2017,
					2018,
					2019,
					2020,
					2021
				]
			}
		],
		"yAxis": [
			{
				"min": 0,
				"max": 100,
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickInterval": 20,
				"minorTickInterval": 10,
				"tickWidth": 1,
				"tickColor": "#231f20",
				"minorTickWidth": 1,
				"minTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}%"
				}
			},
			{
				"linkedTo": 0,
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "",
					"reserveSpace": false,
					"x": null
				}
			}
		],
		"series": [
			{
				"name": "Stage 0",
				"data": [
					{
						"y": 16,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">Stage 0</span>",
							"useHTML": true
						}
					},
					6,
					8,
					5,
					10,
					{
						"y": 1,
						"color": "white"
					},
					10,
					6,
					6,
					10,
					4,
					{
						"y": 1,
						"color": "white"
					},
					4,
					4,
					7,
					1,
					0,
					{
						"y": 1,
						"color": "white"
					},
					3,
					1,
					1,
					4,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "1",
				"data": [
					{
						"y": 7,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">1</span>",
							"useHTML": true
						}
					},
					9,
					8,
					3,
					4,
					{
						"y": 1,
						"color": "white"
					},
					8,
					6,
					5,
					3,
					6,
					{
						"y": 1,
						"color": "white"
					},
					8,
					6,
					1,
					6,
					7,
					{
						"y": 1,
						"color": "white"
					},
					1,
					6,
					5,
					2,
					3
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2a",
				"data": [
					{
						"y": 4,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2a</span>",
							"useHTML": true
						}
					},
					4,
					5,
					2,
					4,
					{
						"y": 1,
						"color": "white"
					},
					2,
					6,
					4,
					3,
					1,
					{
						"y": 1,
						"color": "white"
					},
					1,
					4,
					4,
					1,
					0,
					{
						"y": 1,
						"color": "white"
					},
					2,
					2,
					1,
					2,
					0
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "2b",
				"data": [
					{
						"y": 5,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">2b</span>",
							"useHTML": true
						}
					},
					0,
					4,
					3,
					4,
					{
						"y": 1,
						"color": "white"
					},
					3,
					3,
					4,
					2,
					3,
					{
						"y": 1,
						"color": "white"
					},
					3,
					2,
					2,
					0,
					2,
					{
						"y": 1,
						"color": "white"
					},
					2,
					1,
					3,
					2,
					1
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "3",
				"data": [
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": true,
							"overflow": "none",
							"align": "left",
							"y": 2,
							"style": {
								"color": "white",
								"fontSize": "0.7em"
							},
							"format": "<span style=\"padding-left: 4px;\">3</span>",
							"useHTML": true
						}
					},
					1,
					2,
					2,
					3,
					{
						"y": 1,
						"color": "white"
					},
					4,
					5,
					1,
					6,
					4,
					{
						"y": 1,
						"color": "white"
					},
					2,
					2,
					3,
					1,
					3,
					{
						"y": 1,
						"color": "white"
					},
					6,
					7,
					3,
					6,
					4
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 0,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "< 30"
			},
			{
				"x": 6,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "30–39"
			},
			{
				"x": 12,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "40–49"
			},
			{
				"x": 18,
				"offset": -14,
				"y": 55,
				"align": "left",
				"text": "≥ 50"
			}
		],
		"dataTable": {
			"groups": [
				"< 30",
				"30–39",
				"40–49",
				"≥ 50"
			],
			"header": [
				2017,
				2018,
				2019,
				2020,
				2021,
				2017,
				2018,
				2019,
				2020,
				2021,
				2017,
				2018,
				2019,
				2020,
				2021,
				2017,
				2018,
				2019,
				2020,
				2021
			],
			"rows": [
				{
					"name": "Stage 0",
					"data": [
						16,
						6,
						8,
						5,
						10,
						10,
						6,
						6,
						10,
						4,
						4,
						4,
						7,
						1,
						0,
						3,
						1,
						1,
						4,
						1
					]
				},
				{
					"name": "Stage 1",
					"data": [
						7,
						9,
						8,
						3,
						4,
						8,
						6,
						5,
						3,
						6,
						8,
						6,
						1,
						6,
						7,
						1,
						6,
						5,
						2,
						3
					]
				},
				{
					"name": "Stage 2a",
					"data": [
						4,
						4,
						5,
						2,
						4,
						2,
						6,
						4,
						3,
						1,
						1,
						4,
						4,
						1,
						0,
						2,
						2,
						1,
						2,
						0
					]
				},
				{
					"name": "Stage 2b",
					"data": [
						5,
						0,
						4,
						3,
						4,
						3,
						3,
						4,
						2,
						3,
						3,
						2,
						2,
						0,
						2,
						2,
						1,
						3,
						2,
						1
					]
				},
				{
					"name": "Stage 3",
					"data": [
						0,
						1,
						2,
						2,
						3,
						4,
						5,
						1,
						6,
						4,
						2,
						2,
						3,
						1,
						3,
						6,
						7,
						3,
						6,
						4
					]
				},
				{
					"name": "Unknown Stage",
					"data": [
						0,
						1,
						2,
						1,
						2,
						1,
						2,
						2,
						2,
						5,
						2,
						2,
						1,
						0,
						3,
						1,
						0,
						1,
						0,
						2
					]
				},
				{
					"name": "Total (n=)",
					"data": [
						32,
						21,
						29,
						16,
						27,
						28,
						28,
						22,
						26,
						23,
						20,
						20,
						18,
						9,
						15,
						15,
						17,
						14,
						16,
						11
					]
				}
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"resources": {
		"files": "./vendor/pattern-fill-v2.js"
	},
	"outfile": "./temp/png/figure_vcha_4_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_4_3.json
// module id = 300
// module chunks = 0